define('appkit/loader.helper',[
  'backbone',
  'underscore',
  'datakit/ajax'
], function(Backbone, _, ajax){

  var LoaderHelper = Backbone.Model.extend({

    constructor: function(models, options) {
      this.requesting = 0;
      options = _.extend({ delay: 1000 }, options);
      this.options = options;
      this.attributes = {};
      this.set({ loading: false });
      this.changed = {};
      _.each(_.isArray(models) ? models : (models ? [models]: null), function(model) {
        this.add(model);
      }, this);
      if (options.dimmer) {
        this.bindDimmer(options.dimmer);
      }
    },

    bindDimmer: function(dimmer) {
    // this does not make sense to use...
    //   var content = new ComponentCollectionView(),
    //       loader  = new Loader({ active: false }),
    //       button  = new ButtonView({ text: 'Retry', visible: false, color: 'red', inverted: true, icon: 'refresh' }),
    //       error   = new ErrorView();

    //   this.on('change:error', function() {
    //     if (!!this.get('error')) {
    //       dimmer.active = true;
    //       button.visible = true;
    //       error.visible = true;
    //     } else {
    //       error.visible = false;
    //       button.visible = false;
    //     }
    //   });

    //   dimmer.content = content;

      return this;
    },

    add: function(model) {
      this.listenTo(this, 'retry', function() {
        model.fetch();
      });
      this.listenTo(model, 'request', function() {
        var self = this;

        this.requesting++;
        if (this.requesting == 1) {
          // on first run we want to set loading synchronously 
          // because that is usually when the page changes
          if (this._alreadyRun && !this.get('error')) {
            setTimeout(function() {
              // if we are still making requests then
              // set loading to true
              if (self.requesting > 0) {
                self.set('loading', true);
              }
            }, this.options.delay);
          } else {
            this._alreadyRun = true;
            this.set('loading', true);
          }
        }
      });

      // must listen for destroy as well as sync.  when a model in
      // a collection is destroyed, the collection's listeners on
      // the model get unbound, and they will never pick up the 
      // sync event.  (which IS still fired on the model)
      this.listenTo(model, 'sync error destroy request:success', function() {
        this.requesting--;
        if (this.requesting <= 0) {
          this.requesting = 0;
          this.set('loading', false);
        }
      });
      this.listenTo(model, 'error', function(model, err, options) {
        if (err instanceof ajax.AbortError) {
          return;
        }
        this.set('error', err.message);
      });
      return model;
    }

  });

  return LoaderHelper;
});
